/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Atelier_Point_3Inputs */

const en_atelier_point_3 = /** @type {(inputs: Atelier_Point_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Returns to the vendor, agreed in one place`)
};

/**
* | output |
* | --- |
* | "Returns to the vendor, agreed in one place" |
*
* @param {Atelier_Point_3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const atelier_point_3 = /** @type {((inputs?: Atelier_Point_3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Atelier_Point_3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_atelier_point_3(inputs)
});